import * as THREE from 'three'

import Experience from '../Experience'

import vertexShader from '../shaders/cosmos/cosmos.vert'
import fragmentShader from '../shaders/cosmos/cosmos.frag'

import gsap from 'gsap'

let instance = null

export default class Cosmos {
  constructor() {
    if (instance) {
      return instance
    }

    instance = this
        
    this.experience = new Experience()
    this.scene = this.experience.scene
    this.debug = this.experience.debug

    this.createParticles()
  } 

  createParticles() {
    let count = 2500
    let position = new Float32Array(count * 3)
    let size = new Float32Array(count)
    let speed = new Float32Array(count)
    let index = new Float32Array(count)
    let opacity = new Float32Array(count)
    let boxSize = 8

    for (let i = 0; i < count; i++) {
      let x = Math.random() * boxSize - boxSize / 2
      let y = Math.random() * boxSize - boxSize / 2
      let z = Math.random() * boxSize - boxSize / 2

      position.set([x, y, z], i * 3);

      size[i] = (1.0 + Math.random()) * 10
      speed[i] = 0.01 + Math.random() * 0.025
      index[i] = i / count
      opacity[i] = 0.5 + Math.random() * 0.5
    }

    this.geometry = new THREE.BufferGeometry()

    this.geometry.setAttribute('position', new THREE.BufferAttribute(position, 3))
    this.geometry.setAttribute('aSize', new THREE.BufferAttribute(size, 1))
    this.geometry.setAttribute('aSpeed', new THREE.BufferAttribute(speed, 1))
    this.geometry.setAttribute('aIndex', new THREE.BufferAttribute(index, 1))
    this.geometry.setAttribute('aOpacity', new THREE.BufferAttribute(opacity, 1))

    this.material = new THREE.ShaderMaterial({
      vertexShader,
      fragmentShader,
      uniforms: {
        uTime: { value: 0 },
        uBoxSize: { value: boxSize },
        uOpacity: { value: 0 },
      },
      transparent: true,
      depthTest: false,
      depthWrite: false,
    })

    this.points = new THREE.Points(this.geometry, this.material)

    this.scene.add(this.points)
  }

  update(time) {
    this.material.uniforms.uTime.value = time
  }

  createTimeline() {
    const tl = gsap.timeline()

    tl
      .to(this.material.uniforms.uOpacity, {
        duration: 1,
        value: 1,
        ease: 'power3.inOut',
      })
  }
}